<template>
  <div>
    <ThemedComponent
      path="Page"
      :component-name="`Tag${slugPageInfo?.componentName}`"
    />
  </div>
</template>

<script setup lang="ts">
import { LANGUAGES } from '~/constants/language'

definePageMeta({
  alias: LANGUAGES.map(lang => `/${lang}/:slug/tags/:slugTag`),
})

await useResolvedMenuRoute()
const { slugPageInfo } = useNavigationMenu()

if (!slugPageInfo.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found' })
}
</script>
